module.exports = __webpack_public_path__ + "img/3.a3e3298f.jpg";